import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

// Consistent quick links shown on every page (except the landing hero).
// Links are side-by-side, in order, and cover the primary destinations.
const LINKS = [
  { to: '/', label: 'Home' },
  { to: '/jobs', label: 'Jobs' },
  { to: '/for-employers', label: 'Employers' },
  { to: '/find-a-supervisor', label: 'Find LCSW-S Supervisor' },
  { to: '/internships', label: 'Internships' },
  { to: '/internship-portal', label: 'Internship Portal' },
  { to: '/community/ask-a-social-worker', label: 'Ask a Social Worker' },
  { to: '/community/resources', label: 'Community Resources' },
  { to: '/license-renewal-center', label: 'License Center' },
  { to: '/advance-directives', label: 'Advance Directives' },
];

const QuickLinksBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  if (location.pathname === '/') return null;

  return (
    <div className="sticky top-16 z-30 bg-primary/95 backdrop-blur border-b border-white/10" data-testid="quick-links-bar">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 flex items-center gap-2 h-11">
        <button
          onClick={() => (window.history.length > 1 ? navigate(-1) : navigate('/'))}
          className="flex items-center gap-1 text-white/90 hover:text-secondary text-sm font-medium flex-shrink-0 pr-2 border-r border-white/20"
          data-testid="back-button"
          aria-label="Go back"
        >
          <ChevronLeft className="w-4 h-4" /> Back
        </button>
        <nav className="flex items-center gap-1 overflow-x-auto scrollbar-hide" data-testid="quick-links-nav">
          {LINKS.map((l) => {
            const active = location.pathname === l.to;
            return (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`quicklink-${l.label.toLowerCase().replace(/[^a-z]+/g, '-')}`}
                className={`whitespace-nowrap text-xs sm:text-sm px-3 py-1.5 rounded-full transition-colors ${active ? 'bg-secondary text-white' : 'text-white/85 hover:bg-white/10'}`}
              >
                {l.label}
              </Link>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default QuickLinksBar;
